<template>
    <div id="metodosPagoStripe">

        <div class="text-center mt-5 mb-5" v-if="!isLoaded">
            <b-spinner label="Loading..."></b-spinner>
        </div>

        <template v-else>

            <b-card class="mb-3 p-2" no-body>
                <div class="text-right">
                    <b-button variant="primary" @click="newPaymentMethod" class="mb-2">
                        Agregar método de pago
                    </b-button>
                </div>
            </b-card>

            <filters-handler class="filters-handler" :items-count="totalRows" v-model="filters" :per-page="perPage" no-search/>

            <b-card v-for="method in paginatedMethods" :key="method.id" class="mt-3">
                <b-card-title class="mb-0">
                    **** **** **** {{ method.card.last4 }}
                </b-card-title>
                <b-row class="info" >
                    <b-col>
                        <b-card-text>
                            Expiración: {{ method.card.exp_month }}/{{ method.card.exp_year }}
                            <br>
                            <small>
                                Fecha de alta: {{ (new Date(method.created * 1000).toLocaleDateString()) }}
                            </small>
                        </b-card-text>
                    </b-col>
                    <b-col class="text-right">
                        <b-card-text>
                            {{ method.card.brand | uppercase }}
                        </b-card-text>
                    </b-col>
                    <!-- <b-col v-if="allowSelect" cols="1">
                        <b-form-checkbox v-model="pmSelected" :value="method.id"></b-form-checkbox>
                    </b-col> -->
                </b-row>
                <template v-if="allowSelect" #footer>
                    <div class="text-right">
                        <b-button-group size="sm">
                            <b-button v-if="pmSelected == method.id" @click="pmSelected = method.id" variant="primary">
                                Seleccionado
                            </b-button>
                            <b-button v-else @click="pmSelected = method.id" variant="outline-primary">
                                Seleccionar
                            </b-button>
                        </b-button-group>
                    </div>
                </template>
                <template v-else #footer>
                    <div class="text-right">
                        <b-button-group size="sm">
                            <b-button v-if="method.id == defaulMethod" variant="secondary" disabled>
                                Por defecto
                            </b-button>
                            <template v-else>
                                <b-button @click="setDefaultMethod(method.id)" variant="outline-secondary">
                                    Establecer por defecto
                                </b-button>
                                <b-button @click="askAndDeleteMethod(method.id)" variant="outline-danger">
                                    Eliminar
                                </b-button>
                            </template>
                        </b-button-group>
                    </div>
                </template>
            </b-card>

            <b-jumbotron v-if="totalRows === 0" class="mt-2 mb-2">
                <template #header>
                    Actualmente no tienes ningún método de pago registrado
                </template>
                <p>
                    Para gestionar tus métodos de pago, primero registra tu número físico o solicita tu eSIM.
                </p>
            </b-jumbotron>

        </template>

        <metodos-pago-nuevo ref="metodosPagoNuevo" @paymentAdded="loadUp"/>

    </div>
</template>

<script>
import filtersHandler from '../daniel/filtersHandler'
import _ from 'lodash'
import axios from 'axios';
import metodosPagoNuevo from './metodos-pago-nuevo.vue';
import { BSpinner, BCard, BCardGroup, BCardTitle, BCardText, BPagination } from 'bootstrap-vue';
import { confirmFirst, notify } from '../../../utils';
import stripeObj from '../daniel/stripeHandler'

export default {
    name: 'metodosPagoStripe',
    components: {
        filtersHandler,
        BSpinner,
        BCard,
        BCardGroup,
        BCardTitle,
        BCardText,
        BPagination,
        metodosPagoNuevo
    },
    props: {
        value: {
            type: [String, Number]
        },
        allowSelect: {
            type: Boolean,
            default: false
        },
        perPage: {
            type: Number,
            default: 10
        }
    },
    data() {
        return {
            isLoaded: true,
            paymentMethods: [],
            defaulMethod: null,
            pmSelected: null,
            currentPage: 1,
            filters: {
                term: '',
                page: 1
            }
        };
    },
    computed: {
        totalRows() {
            return this.paymentMethods.length;
        },
        paginatedMethods() {
            const start = (this.filters.page - 1) * this.perPage;
            const end = start + this.perPage;
            return this.paymentMethods.slice(start, end);
        }
    },
    methods: {
        newPaymentMethod() {
            if('metodosPagoNuevo' in this.$refs && this.$refs.metodosPagoNuevo)
                this.$refs.metodosPagoNuevo.open();
            else
                console.error('metodosPagoNuevo ref not found');
        },
        async askAndDeleteMethod(pmID) {
            const confirmed = await confirmFirst('¿Desea eliminar este método de pago?');
            if (confirmed) {
                try {
                    const response = await axios.delete('stripeutils/removestripepaymentmethod/' + pmID);
                    if (!_.isObjectLike(response))
                        throw 'Error en la respuesta el servidor';
                    if (response.status) {
                        this.loadUp()
                    } else throw response.msg
                } catch (e) {
                    console.error(e);
                    notify(e)
                }
            }
        },
        async setDefaultMethod(pmID) {
            try {
                const response = await axios.get('stripeutils/makepmdefault/' + pmID);
                if (!_.isObjectLike(response))
                    throw 'Error en la respuesta el servidor';
                if (response.status) {
                    this.defaulMethod = pmID;
                }
                else throw response.msg
            } catch (e) {
                console.error(e);
                notify(e)
            }
        },
        async loadUp() {
            this.isLoaded = false;
            this.paymentMethods = [];
            this.defaulMethod = null;
            try {
                const response = await axios.get('stripeutils/getpaymentmethods')
                if (!_.isObjectLike(response))
                    throw 'Error en la respuesta el servidor';

                if('stripePublicKey' in response)
                    stripeObj.setStripePublicKey(response.stripePublicKey)

                if (response.status) {
                    this.paymentMethods = response.data;
                    this.defaulMethod = response.default;
                } else throw response.msg
            } catch (e) {
                console.error(e)
                notify(e)
            }
            this.isLoaded = true;
        }
    },
    beforeMount() {
        this.pmSelected = _.clone(this.value)
    },
    mounted() {
        this.loadUp()
    },
    watch: {
        pmSelected(){
            this.$emit('input', this.pmSelected)
        }
    }
};
</script>

<style lang="scss">
@import '@/sass/utils/_variables.scss';

#metodosPagoStripe {
    color: $text-color;

    .card {
        background-color: $primary-dark;
    }
    
    .badge-primary {
        color: #fff;
        background-color: $accent;
    }

    .info {
        color: $accent-dimmed;
    }

    .filters-handler {
		margin: 0;
	}
}
</style>